var map = {
	"./abstellplatzl.svg": 3,
	"./arrow-accordion.svg": 4,
	"./arrow-green.svg": 5,
	"./arrow-link.svg": 6,
	"./arrow-select-rotated.svg": 7,
	"./arrow-select.svg": 8,
	"./arrow-slider-left.svg": 9,
	"./arrow-slider-right.svg": 10,
	"./arrow-white.svg": 11,
	"./arrow.svg": 12,
	"./badeplatzl.svg": 13,
	"./berg-gesund-platzl.svg": 14,
	"./check-white.svg": 15,
	"./facebook.svg": 16,
	"./family-child.svg": 17,
	"./insta.svg": 18,
	"./kraftplatzl.svg": 19,
	"./lieblingsplatzl.svg": 20,
	"./mountains.svg": 21,
	"./parkplatzl.svg": 22,
	"./phone.svg": 23,
	"./rezeption-platzl.svg": 24,
	"./schlafplatzl.svg": 25,
	"./snowflake-price.svg": 26,
	"./sonnplatzl.svg": 27,
	"./sun.svg": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;